<template>
  <div :class="['input', dark ? 'dark_input' : '', round ? 'round_input': '']" 
       :style="`width: ${width && width.length ? width : '100%'}`">
    <p class="input__name" 
       v-if="field_name">
       {{ field_name }} 
       <span style="color: red" v-if="required">*</span>
    </p>

    <div :class="['input__textinput', disabled ? 'disabled' : '', error ? 'error_input' : '']" >
      <div class="icon" v-if="icon">
        <img :src="`/img/${icon}.svg`">
      </div>
      <input :type="type ? type : 'text'"
             :value="modelValue"
             :class="['inside_input']"
             :disabled='disabled'
             @input="$emit('update:modelValue', $event.target.value)" 
             :required="required"
             :placeholder="placeholder"
             :style="`width: ${loading ? '70%' : '' }`" />

        <span v-if="loading" class="spinner small"></span>

    </div>
    <small class="hint">{{ hint }}</small>
    <p class="error" v-if="error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: 'text-input',

  props: {
    "modelValue": String,
    "field_name": String,
    "width": String,
    "placeholder": String,
    'icon': String,
    'hint': String,
    'required': Boolean,
    'error': String,
    'type': String,
    'disabled': Boolean,
    'loading': Boolean,
    'dark': Boolean,
    'round': Boolean
  },

  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/style.sass"
</style>